<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation().default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 items-center p-6 pb-0 gap-3">
            <img
                class="w-16"
                src="images/logo/padelhub_logo.png"
                alt="Logo image"
            />
            <div class="flex flex-col">
                <span class="text-3xl font-semibold tracking-wider text-blue-100">PadelHub</span>
                <div class="text-sm text-gray-400">
                    <span>Version: {{appVersion}} </span>
                </div>
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Shared Header -->
    <ph-header
        [showMenuToggle]="isScreenSmall"
        (menuToggle)="toggleNavigation('mainNavigation')"
    ></ph-header>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>
</div>
